export default "__VITE_ASSET__CjfKJOVW__"